var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "js-apartment-inputs" }, [
    _c("div", { staticClass: "integer-input" }, [
      _c("label", { staticClass: "control-label integer-input-label" }, [
        _vm._v(
          _vm._s(_vm.apartmentSize.label) +
            " (" +
            _vm._s(_vm.apartment.area) +
            "m²)"
        )
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn--round",
          attrs: {
            type: "button",
            disabled: !_vm.isApartmentDecreasable || _vm.isProjectClosed,
            title: _vm.minValue
          },
          on: {
            click: function($event) {
              _vm.decreaseApartment()
            }
          }
        },
        [_c("span", { staticClass: "glyphicon glyphicon-minus" })]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "integer-input-value" }, [
        _vm._v(_vm._s(_vm.apartment.count) + " ")
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn--round",
          attrs: {
            type: "button",
            disabled: !_vm.isApartmentIncreasable || _vm.isProjectClosed,
            title: _vm.maxValue
          },
          on: {
            click: function($event) {
              _vm.increaseApartment()
            }
          }
        },
        [_c("span", { staticClass: "glyphicon glyphicon-plus" })]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{}!./~/vue-loader/lib?{}!./assets/vue/houseModel/components/houseApartment.vue?vue&type=template&id=e2563188&
// module id = 499
// module chunks = 0